export default "__VITE_ASSET__1236f7b9__"